import styled from 'styled-components';
import React from 'react';
import { FormInput, Icon } from '@alpine-iq/ui-library';

export default styled(FormInput).attrs({
	'aria-label': 'Search',
	'size': 'medium',
	'placeholder': 'Search',
	'leftAdornment': (
		<Icon
			height={'22px'}
			width={'22px'}
			type="SEARCH"
		/>
	),
})`
	[data-base-input-outline] {
		border-width: 2px;
		border-radius: 40px;
		height: 40px;
		max-height: 40px;
	}
	input {
		font-family: 'Manrope', sans-serif;
		padding-left: 5px;
		height: 40px !important;
		max-height: 40px !important;
		padding-block: 0px !important;
	}
`;

export const MiniSearchFormInput = styled(FormInput).attrs({
	'aria-label': 'Search',
	'placeholder': 'Search',
	'size': 'small',

	'leftAdornment': (
		<Icon
			height={'16px'}
			width={'16px'}
			type="SEARCH"
		/>
	),
})`
	[data-base-input-outline] {
		border-width: 2px;
		border-radius: 40px;
	}
	input {
		font-family: 'Manrope', sans-serif;
		padding-left: 5px;
	}
`;

export const SearchFormInput = styled(FormInput).attrs({
	'aria-label': 'Search',

	'leftAdornment': (
		<Icon
			height={'22px'}
			width={'22px'}
			type="SEARCH"
		/>
	),
})`
	[data-base-input-outline] {
		border-width: 2px;
		border-radius: 40px;
	}
	input {
		font-family: 'Manrope', sans-serif;
		padding-left: 5px;
	}
`;
